/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `personal_finance` - Życie
 * * `business_finance` - Firma
 * * `iot_gec` - IoT/GEC
 * * `ranking` - Ranking
 * * `life_line` - Przyszłość
 */
export type ModuleEnum = typeof ModuleEnum[keyof typeof ModuleEnum];


export const ModuleEnum = {
  personal_finance: 'personal_finance',
  business_finance: 'business_finance',
  iot_gec: 'iot_gec',
  ranking: 'ranking',
  life_line: 'life_line',
} as const;
